import { render, staticRenderFns } from "./reply-again.vue?vue&type=template&id=585fbb0a&"
import script from "./reply-again.vue?vue&type=script&lang=js&"
export * from "./reply-again.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports